/**
 * Created by mqamhieh on 2/20/17.
 */
window.TeamScheduleV2API = new function () {

    var self = this;

    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.getBaseAPI("TSTeamScheduleServers") : publicConfiguration.getBaseAPI("TeamScheduleServers");
    _protected.setApiUrl(url);

    var scheduleVersioningMap = {};

    self.updateScheduleVersion = function (scheduleId) {
        if (scheduleVersioningMap[scheduleId]) {
            scheduleVersioningMap[scheduleId]['unpublished_version']++;
        }
    };

    self.setScheduleVersion = (schedule, mode) => {

        var version = mode === 'PUBLISHED'? schedule['published_version']: schedule['unpublished_version'];
        var scheduleId = schedule['id'];

        scheduleVersioningMap[scheduleId] = scheduleVersioningMap[scheduleId] || { brand_id: schedule['brand_id'], start_date: schedule['start_date']};

        if (!isNaN(version)) {
            if (mode === 'PUBLISHED') {
                scheduleVersioningMap[scheduleId]['published_version'] = version;
            }

            if (mode === 'UNPUBLISHED') {
                scheduleVersioningMap[scheduleId]['unpublished_version'] = version;
            }
        }
    };

    self.getScheduleVersioning = function (scheduleId) {
        return scheduleVersioningMap[scheduleId];
    };

    self.loadScheduleVersion = function (brandId, date) {
        var defer = $q.defer();

        var params = {
            dates: moment(date).format("MMM DD, YYYY")
        };

        _protected.request("brands/" + brandId + "/schedule", "GET", params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200 && res.data.data) {
                    var scheduleData = res.data.data.schedule || [];
                    var schedule = scheduleData[0] || {};
                    defer.resolve(schedule);
                }
                else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    var ignoreCache = false;

    self.getBrandSchedule = function (brandId, weekOrDays, employeeId, mode, useCache) {
        var deferred = $q.defer();

        var params = {};

        if (typeof(weekOrDays) == 'object') {
            params['days'] = weekOrDays;
        }
        else {
            params['week'] = weekOrDays;
        }

        params['mode'] = mode || 'UNPUBLISHED';

        if(employeeId) {
            params['employee_id'] = employeeId;
        }

        var requestIdentifier = brandId + JSON.stringify(params);
        var cached = _protected.getCached(requestIdentifier);

        _protected.clearCache(requestIdentifier);

        if (cached) {
            deferred.resolve(cached);
            return deferred.promise;
        }

        if (!useCache) {
            ignoreCache = true;
        }

        _protected.request("brands/" + brandId + "/schedule", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    var scheduleData = res.data.data.schedule || [];

                    if (params['week']) {
                        var schedule = scheduleData[0] || {};
                        var scheduleId = schedule['id'];

                        if (scheduleId) {
                            self.setScheduleVersion(schedule, params['mode']);
                        }
                    }

                    if (useCache && !ignoreCache) {
                        _protected.cache(requestIdentifier, scheduleData);
                    }

                    deferred.resolve(scheduleData);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeBrandSchedule = function (brandId, weekOrDays, employeeId, mode, level) {
        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        var params = {};

        if (typeof(weekOrDays) == 'object') {
            params['days'] = weekOrDays;
        }
        else {
            params['week'] = weekOrDays;
        }

        params['mode'] = mode || 'UNPUBLISHED';

        if(employeeId) {
            params['employee_id'] = employeeId;
        }

        params['level'] = level || 'BUSINESS';


        _protected.request("employees/brands/" + brandId + "/schedule", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    var scheduleData = res.data.data.schedule || [];

                    if (params['week']) {
                        var schedule = scheduleData[0] || {};
                        var scheduleId = schedule['id'];

                        if (scheduleId) {
                            self.setScheduleVersion(schedule, params['mode']);
                        }
                    }

                    deferred.resolve(scheduleData);
                }
                else {
                    deferred.reject(res);
                }
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.changeBrandScheduleLock = function (brandId, scheduleId, isLocked) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "Can't lock schedule without brand id";
        }

        var urlParts = ["brands", brandId, "schedule", scheduleId, isLocked? "lock": "unlock"];

        _protected.request(urlParts.join("/"), "POST")
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get the scheduled shifts across all other locations except the one called
     *
     * @param brandId
     * @param employeeId
     */
    self.getBrandCrossSchedules = (brandId, params = {}, useCache) => {
        var deferred = $q.defer();

        const paramsToSend = {};

        if (!brandId) {
            throw "Can't call get schedule without brand id";
        }

        if (params.days) {
            paramsToSend.days = params.days;
        }
        if (params.week) {
            paramsToSend.week = params.week;
        }

        if (params.employeeId) {
            paramsToSend.employee_id = params.employeeId;
        }

        if (params.fromDay) {
            paramsToSend.from_day = params.fromDay;
        }

        if (params.toDay) {
            paramsToSend.to_day = params.toDay;
        }

        var requestIdentifier = brandId + JSON.stringify(paramsToSend);
        var cached = _protected.getCached(requestIdentifier);

        if (cached) {
            deferred.resolve(cached);
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/cross_schedules", "GET", paramsToSend)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    if (useCache) {
                        _protected.cache(requestIdentifier, res.data.data.schedule || []);
                    }

                    deferred.resolve(res.data.data.schedule || []);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.bulkEditShifts = function (brandId, scheduleId, shifts) {
        var deferred = $q.defer();

        self.updateScheduleVersion(scheduleId);

        _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/shifts", "PUT", { shifts: shifts })
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.editShift = function (brandId, scheduleId, shiftId, data) {
        var deferred = $q.defer();

        data.start_time = moment(data.start_time).format("MMM D, YYYY HH:mm");
        data.end_time = moment(data.end_time).format("MMM D, YYYY HH:mm");

        if (data.labels && !data.labels.length) {
            delete data.labels;
        }

        if (data.template_id) {
            delete data.code;
            delete data.weight;
        }

        self.updateScheduleVersion(scheduleId);

        _protected.uniqueRequest("brands/" + brandId + "/schedules/" + scheduleId + "/shifts/" + shiftId, "PUT", data)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editShifts = function (brandId, scheduleId, shifts) {
        var deferred = $q.defer();

        self.updateScheduleVersion(scheduleId);

        _protected.uniqueRequest("brands/" + brandId + "/schedules/" + scheduleId + "/shifts", "PUT", {shifts: shifts})
            .then(function (res) {
                    if (res.data && res.data.status_code === 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandShiftsTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/shifts/templates", "GET")
            .then(function (res) {

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewShift = function (brandId, scheduleId, data) {
        var deferred = $q.defer();

        if (data.start_time) {
            data.start_time = moment(data.start_time).format("MMM D, YYYY HH:mm");
        }

        if (data.end_time) {
            data.end_time = moment(data.end_time).format("MMM D, YYYY HH:mm");
        }

        if (!data.user_id && !data.assignee_id) {
            data.user_id = null;
        }

        if (data.labels && !data.labels.length) {
            delete data.labels;
        }

        if (data.template_id) {
            delete data.code;
            delete data.weight;
        }

        self.updateScheduleVersion(scheduleId);

        _protected.uniqueRequest("brands/" + brandId + "/schedules/" + scheduleId + "/shifts", "POST", data)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteScheduleShift = function (scheduleId, assigneeId, shiftId, params) {
        var deferred = $q.defer();

        if (typeof shiftId !== 'number') {
            deferred.reject('shift id should be of type number');
            return deferred.promise;
        }

        _protected.request("assignees/" + assigneeId + "/shifts/" + shiftId, "DELETE", params)
            .then(function (res) {
                self.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                self.updateScheduleVersion(scheduleId);
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.restoreDeletedShifts = function (brandId, scheduleId, shiftId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'no brand id';
        }

        self.updateScheduleVersion(scheduleId);

        _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/shifts/" + shiftId + "/restore" , "POST")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getEmployeeLabelsAssignedByBrand = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("No brand id passed");
        } else {
            _protected.request("employees/brands/" + brandId + "/labels", "GET")
                .then(function (res) {

                        if (res.data && res.data.data && res.data.status_code == 200) {
                            deferred.resolve(res.data.data.labels);
                        }
                        else {
                            deferred.reject(res);
                        }
                    },
                    function (err) {
                        deferred.reject(err);
                    });
        }

        return deferred.promise;
    };

    self.getCalendarSyncSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('employees/brands/' + brandId + '/calendar_sync_settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateCalendarSyncSettings = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('employees/brands/' + brandId + '/calendar_sync_settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //TODO reset when close the timesheet.
    [self.getBrandLabels, self.resetBrandLabels] = cacheService.cache((brandId) => {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/labels", "GET")
            .then(function (res) {

                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.labels);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    });

    self.getEmployeeBrandLabels = function (brandId) {
        var deferred = $q.defer();

        var params = {
            brand_id: brandId
        };

        _protected.request("employees/labels", "GET", params)
            .then(function (res) {

                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data.labels);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.createShiftLabel = function (brandId, data) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/labels", "POST", data)
            .then(function (res) {

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.removeUnassignedEmployees = function (scheduleId, assigneesIds) {

        var deferred = $q.defer();

        var params = {
            ids: assigneesIds
        };

        _protected.request("schedules/" + scheduleId + "/roles/assignees", "DELETE", params)
            .then(function (res) {
                self.updateScheduleVersion(scheduleId);

                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                self.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addAvailableEmployee = function (scheduleId, userIds, day, positionCode) {
        var deferred = $q.defer();

        var params = {
            ids: userIds
        };

        var urlParam = day? "?day=" + day: "";

        _protected.uniqueRequest("schedules/" + scheduleId + "/positions/" + positionCode + "/users" + urlParam, "POST", params)
            .then(function (res) {
                    self.updateScheduleVersion(scheduleId);

                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    self.updateScheduleVersion(scheduleId);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    // retrieve users swapped/offered/picked shifts
    self.getUsersOfferedShifts = function (brandId, date, type, isVSLoptedIn, isDay) {
        var deferred = $q.defer();
        var params = {
            status: 'APPROVED'
        };

        if (isDay) {
            params['day'] = moment(date).format('YYYY-MM-DD');
        } else {
            params['week'] = moment(date).format('YYYY-MM-DD');
        }

        if (type) {
            params['type'] = type;
        }

        if (isVSLoptedIn) {
            params['is_unassigned_vsl_offeree_opted_in'] = isVSLoptedIn;
        }

        _protected.request("brands/" + brandId + "/users/offers", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getIncentivePaymentFixedSettings = async (brandId) => {
        if (!brandId) {
            throw "No brand id";
        }

        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/fixed`, 'GET');

        if (result?.data?.status_code === 200 && result.data?.data) {
            return result.data.data;
        }

        throw result;
    };

    self.updateIncentivePaymentFixedSettings = async (brandId, payload) => {
        if (!brandId) {
            throw "No brand id";
        }

        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/fixed`, 'PUT', payload);

        if (result?.data?.status_code === 200) {
            return true;
        }

        throw result;
    }

    self.getIncentiveExtraPayRuleBasedSettings = async (brandId) => {
        if (!brandId) {
            throw "No brand id";
        }
        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/rule_based`, 'GET');
        if (result?.data?.status_code === 200 && result.data.data) {
            return result.data.data;
        }
        throw result;
    };

    self.addIncentiveExtraPayRuleBasedSettings = async (brandId, payload) => {

        if (!brandId) {
            throw "No brand id";
        }

        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/rule_based`, 'POST', payload);

        if (result?.data?.status_code === 200) {
            return result.data.data;
        }

        throw result;
    };

    self.updateIncentiveExtraPayRuleBasedSettings = async (id, brandId, payload) => {

        if (!brandId) {
            throw "No brand id";
        }

        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/rule_based/${id}`, 'PUT', payload);

        if (result?.data?.status_code === 200) {
            return result.data.data;
        }

        throw result;
    };

    self.deleteIncentiveExtraPayRuleBasedSettings = async (id, brandId) => {
        if (!brandId) {
            throw "No brand id";
        }

        let result = await _protected.request(`brands/${brandId}/settings/incentive_payment/rule_based/${id}`, 'DELETE');

        if (result?.data?.status_code === 200) {
            return result.data.data;
        }

        throw result;
    };

    self.resetIgnoreCache = function () {
        ignoreCache = false;
    };

    self.reset = function () {
        scheduleVersioningMap = {};
    };
};

TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES = {};
TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PUBLISHED = 'PUBLISHED';
TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED = 'UNPUBLISHED';
TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PARTIALLY_PUBLISHED = 'PARTIALLY_PUBLISHED';
